((document, Drupal) => {
  "use strict";

  const focusableSelector = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "iframe",
    "[tabindex]",
  ].join(", ");

  Drupal.behaviors.heroes = {
    attach: function (context) {
      if (!document.querySelector(".heroes.swiper")) return;
      const heroes = document.querySelectorAll(".heroes");

      heroes.forEach((slider, index) => {
        if (slider.dataset.heroesInitialized === "true") {
          return;
        }

        slider.dataset.heroesInitialized = "true";

        const syncTabOrder = () => {
          const slides = slider.querySelectorAll(".hero");

          slides.forEach((slide) => {
            const isActive = slide.classList.contains("swiper-slide-active");
            slide.setAttribute("aria-hidden", isActive ? "false" : "true");
            const focusableElements = slide.querySelectorAll(focusableSelector);

            focusableElements.forEach((element) => {
              if (!element.hasAttribute("data-original-tabindex")) {
                element.setAttribute("data-original-tabindex", element.getAttribute("tabindex") || "");
              }

              if (isActive) {
                const originalTabindex = element.getAttribute("data-original-tabindex");

                if (originalTabindex === "") {
                  element.removeAttribute("tabindex");
                }
                else {
                  element.setAttribute("tabindex", originalTabindex);
                }
              }
              else {
                element.setAttribute("tabindex", "-1");
              }
            });
          });
        };

        const swiper = new Swiper(slider, {
          // Optional parameters
          loop: true,
          slideClass: "hero",
          autoplay: {
            delay: 7000,
            disableOnInteraction: false,
          },

          // Navigation arrows
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on: {
            transitionStart: function (e) {
              syncTabOrder();

              const mobile = window.matchMedia("(max-width: 991px)");
              e.slides.forEach((slide) => {
                const iframe = slide.querySelector("iframe");
                if (iframe && !mobile.matches) {
                  const iframePlayer = new Vimeo.Player(iframe);
                  iframePlayer.pause();
                }
              });
            },
            transitionEnd: function (e) {
              const mobile = window.matchMedia("(max-width: 991px)");
              const slide = e.slides[e.activeIndex];
              const iframe = slide.querySelector("iframe");

              syncTabOrder();

              if (iframe && !mobile.matches) {
                const iframePlayer = new Vimeo.Player(iframe);
                iframePlayer.play();
              }
            },
          },
        });

        const pauseButton = slider.querySelector(".sr-only-pause");
        if (pauseButton && swiper.autoplay) {
          pauseButton.addEventListener("click", () => {
            const isPaused = pauseButton.getAttribute("aria-pressed") === "true";

            if (isPaused) {
              swiper.autoplay.start();
              pauseButton.setAttribute("aria-pressed", "false");
              pauseButton.setAttribute("aria-label", Drupal.t("Pause slideshow"));
              pauseButton.textContent = Drupal.t("Pause Slideshow");
            }
            else {
              swiper.autoplay.stop();
              pauseButton.setAttribute("aria-pressed", "true");
              pauseButton.setAttribute("aria-label", Drupal.t("Play slideshow"));
              pauseButton.textContent = Drupal.t("Play Slideshow");
            }
          });
        }

        syncTabOrder();

        return swiper;
      });
    },
  };
})(document, Drupal);
